var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.9314C8.3682 2.9314 8.66667 3.22988 8.66667 3.59806V8.26473H13.3333C13.7015 8.26473 14 8.5632 14 8.9314C14 9.2996 13.7015 9.59806 13.3333 9.59806H8.66667V14.2647C8.66667 14.6329 8.3682 14.9314 8 14.9314C7.6318 14.9314 7.33333 14.6329 7.33333 14.2647V9.59806H2.66667C2.29848 9.59806 2 9.2996 2 8.9314C2 8.5632 2.29848 8.26473 2.66667 8.26473H7.33333V3.59806C7.33333 3.22988 7.6318 2.9314 8 2.9314Z",
    fill: "#2C8C53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddItem);
export default __webpack_public_path__ + "static/media/add_item.54f8227e5dd2854b8773549ff9027a81.svg";
export { ForwardRef as ReactComponent };